import { useCallback, useEffect, useState } from "react";
import { TicketService } from "../services/TicketService";

export const useHookTicket = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [keyword, setKeyword] = useState("");
    const [nasId, setNasId] = useState("");
    const [popId, setPopId] = useState("");
    const [odpId, setOdpId] = useState("");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [sort, setSort] = useState("asc");
    const [order, setOrder] = useState("name");
const [params, setParams] = useState({});

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await TicketService.get({params});

            const result = res?.data?.data ?? [];

            setData(Array.isArray(result) ? result : []);
            setMeta(res?.data?.meta);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [params]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        meta,
        loading,
        error,

        params, 
        setParams,

        refreshData: getData,
    };
};